import { useCallback, useEffect, useRef, useState } from "react";
import { FiBarChart2, FiCode, FiEdit3, FiSearch } from "react-icons/fi";
import { TbListSearch, TbQuestionMark } from "react-icons/tb";
import { HiArrowTurnRightUp } from "react-icons/hi2";
import { VscJson } from "react-icons/vsc";
import { Dropdown } from "react-bootstrap";
import ErrorMessage from "../Components/ErrorMessage";
import Spinner from "../Components/Spinner";
import ChatMessages from "./AiChatMessages";
import { PiPlugs } from "react-icons/pi";
import ChatLinesLoader from "../Loaders/ChatLinesLoader";
import SingleLoaderItem from "../Loaders/SingleLoaderItem";
import { TiCloudStorageOutline } from "react-icons/ti";
import { MdAttachment, MdOutlineCopyAll, MdOutlineIntegrationInstructions } from "react-icons/md";
import MandatorySign from "../Components/MandatorySign";
import { LuFile, LuFileText, LuImage, LuPen, LuVideo } from "react-icons/lu";
import ThreeDotsLoading from "../Loaders/ThreedotsLoading";
import { useLanguage } from "../Translations/LenguageContext";


const ChatInterface = ({
    account_id,
    chatEndRef,
    userLastMessageRef,
    handleSendMessage,
    handleStopMessage,
    messages = [],
    isLoading,
    errorAi,
    input,
    setInput,
    selectedModel,
    reasoningDepth,
    isMemoryEnabled,
    setIsMemoryEnabled,
    isSearchEnabled,
    isJsonMode,
    connectors,
    loadingChatHistory,
    setIsSearchEnabled,
    setIsJsonMode,
    setConnectors,
    loadingMcpData,
    mcpData,
    files,
    setFiles,
    handleFileInput,
    handleInput,
    removeFile,
    inputRef,
    selectedSystemInstructions,
    steps,
    activeAiMessageId,

    openWebPreview,
    setOpenWebPreview,
    selectedLink,
    setSelectedLink,
    setOpenAbilitiesModal,

    scrollContainerRef,

    loadOlderMessages,
    loadingOlderMessages,
    hasMoreMessages
}) => {
    const { t } = useLanguage()
    // const scrollContainerRef = useRef(null);

    const [showScrollBtn, setShowScrollBtn] = useState(false);
    const [openReasoningIds, setOpenReasoningIds] = useState({});

    const SUGGESTIONS = [
        {
            title: t.playground.suggestions.title_one,
            desc: t.playground.suggestions.subtitle_one,
            icon: <FiSearch className="item_main_icon" />
        },
        {
            title: t.playground.suggestions.title_two,
            desc: t.playground.suggestions.subtitle_two,
            icon: <FiCode className="item_main_icon" />
        },
        {
            title: t.playground.suggestions.title_three,
            desc: t.playground.suggestions.subtitle_three,
            icon: <FiEdit3 className="item_main_icon" />
        },
        {
            title: t.playground.suggestions.title_four,
            desc: t.playground.suggestions.subtitle_four,
            icon: <FiBarChart2 className="item_main_icon" />
        },
    ];


    const focusInput = useCallback(() => inputRef.current?.focus(), []);
    useEffect(() => focusInput(), [messages, isLoading, focusInput]);

    const toggleReasoning = (msgId) => {
        setOpenReasoningIds(prev => ({ ...prev, [msgId]: !prev[msgId] }));
    };

    const onKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey && !isLoading) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    const updateNewMessage = (e, mex_id, editedText) => {
        if (e) e.preventDefault();
        if (!editedText.trim() || isLoading) return;

        handleSendMessage(null, mex_id, editedText);
    };

    const handleScroll = () => {
        if (scrollContainerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current;

            const isAtBottom = scrollHeight - scrollTop <= clientHeight + 100;

            setShowScrollBtn(!isAtBottom);
        }
    };

    const scrollToBottom = () => {
        chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
        // userLastMessageRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const handleClickInput = () => {
        const input_file = document.getElementById("input_file")
        input_file.click()
    }


    const getFileIcon = (name) => {
        if (!name) return <LuFile />;

        const ext = name.split(".").pop().toLowerCase();

        if (["mp4", "mov", "avi", "mkv", "webm"].includes(ext)) {
            return <LuVideo />;
        }

        if (["png", "jpg", "jpeg", "gif", "svg", "webp", "bmp"].includes(ext)) {
            return <LuImage />;
        }

        if (ext === "pdf") {
            return <LuFileText />;
        }

        return <LuFile />;
    };

    return (
        <div className="chat_interface_main" >
            {loadingChatHistory ? (
                <div className="empty_chat_wrapper">
                    <ChatLinesLoader />
                </div>
            ) : (
                messages.length === 0 ? (
                    <div className="empty_chat_wrapper">
                        <div className="empty_chat_interface">
                            <h1 className="empty_chat_interface_title">{t.playground.build_title}</h1>
                            <div className="empty_chat_grid">
                                {SUGGESTIONS.map((item, index) => (
                                    <div key={index} className="empty_chat_interface_item">
                                        <div className="empty_chat_interface_header">
                                            <p className="empty_chat_interface_item_title"><i>{item.icon}</i>{item.title}</p>
                                        </div>
                                        <p className="empty_chat_interface_item_desc">{item.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="chat-wrapper"  >
                        <div
                            className="chat_interface_messages"
                            onScroll={() => {
                                handleScroll()
                            }}
                            ref={scrollContainerRef}
                        >
                            <div className="load_more_messages_btn_cont">

                                {hasMoreMessages && (

                                    <button
                                        type="button"
                                        onClick={loadOlderMessages}
                                        disabled={loadingOlderMessages || !hasMoreMessages}
                                        className="load_more_messages_btn fade-in"
                                    >
                                        {loadingOlderMessages ? (
                                            <><Spinner loading={true} /> {t.loading}</>
                                        ) : (
                                            <><i className="fa-solid fa-arrow-up"></i> {t.playground.more_mex}</>
                                        )}
                                    </button>
                                )}
                            </div>

                            {messages.map((msg) => (
                                <ChatMessages
                                    account_id={account_id}
                                    key={msg.id}
                                    msg={msg}
                                    isSearchEnabled={isSearchEnabled}
                                    openReasoning={!!openReasoningIds[msg.id]}
                                    onToggleReasoning={() => toggleReasoning(msg.id)}
                                    chatEndRef={chatEndRef}
                                    userLastMessageRef={userLastMessageRef}
                                    handleScroll={handleScroll}
                                    errorAi={errorAi}
                                    steps={steps}
                                    activeAiMessageId={activeAiMessageId}

                                    openWebPreview={openWebPreview}
                                    setOpenWebPreview={setOpenWebPreview}
                                    selectedLink={selectedLink}
                                    setSelectedLink={setSelectedLink}
                                    isLoading={isLoading}

                                    updateNewMessage={updateNewMessage}
                                />
                            ))}

                            <div ref={chatEndRef} />
                            {/* <div ref={userLastMessageRef} /> */}
                        </div>
                        {showScrollBtn && (
                            <button
                                className="scroll_down_btn_chat"
                                onClick={scrollToBottom}
                                type="button"
                            >
                                {isLoading ? (
                                    <ThreeDotsLoading />
                                ) : (
                                    <i className="fa-solid fa-chevron-down"></i>
                                )}
                            </button>
                        )}
                    </div>
                )
            )}
            <form className={`chat_interface_input ${isMemoryEnabled && "chat_interface_input_memory"}`} onSubmit={(e) => { e.preventDefault(); handleSendMessage(); }}>
                {isMemoryEnabled && (
                    <div className="memory_tag fade-in">
                        {t.playground.memory_on}
                    </div>
                )}
                <input
                    type="file"
                    multiple
                    className="input_files"
                    id="input_file"
                    onChange={handleFileInput}
                    hidden
                    accept=".txt,.md,.json,.csv,.xls,.xlsx,.pdf"
                />
                <textarea
                    ref={inputRef}
                    className="chat_input_field"
                    placeholder={t.playground.input_placeholder}
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onInput={handleInput}
                    onKeyDown={onKeyDown}
                    rows={1}
                />
                {files.length > 0 && (
                    <div className="attachment_item_cont">
                        {files.slice(0, 3).map((file, i) => (
                            <div key={i} className="attachment_item">
                                <i className="storage_icon">
                                    {getFileIcon(file.name)}
                                </i>
                                <div className="attachment_item_name" title={file.name}>
                                    {file.name}
                                </div>
                                <i
                                    className="fa-solid fa-x"
                                    onClick={() => removeFile(i)}
                                    style={{ cursor: "pointer" }}
                                ></i>
                            </div>
                        ))}

                        {files.length > 3 && (
                            <div className="attachment_item more_files">
                                +{files.length - 3}
                            </div>
                        )}
                    </div>
                )}
                <div className="chat_interface_input_footer">
                    <div className="chat_interface_input_footer_btn_cont">
                        <Dropdown autoClose={"outside"}>
                            <Dropdown.Toggle
                                as="button"
                                type="button"
                                className="more_option_chat no-caret"
                                id="dropdown-custom-components"
                            >
                                <i className="fa-solid fa-plus"></i>
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="custom_dropdown_menu">

                                <div className="dropdown_container fade-in">
                                    <div className="settings_link settings_link_actions" onClick={handleClickInput}>
                                        <p><i><MdAttachment /></i> {t.playground.add_files_docs}</p>
                                    </div>

                                    {/* <div className="settings_link settings_link_actions">
                                        <p><i><TiCloudStorageOutline /></i> Storage</p>
                                        </div> */}
                                    <span className="hr_divider"></span>
                                    <button className="sidebar_btn_ab" onClick={() => setOpenAbilitiesModal(true)}>{t.playground.open_abilities}</button>
                                    <div className="settings_link settings_link_actions">
                                        <p>
                                            {t.playground.memory}
                                            <MandatorySign message={t.playground.memory_mex} icon="info" />
                                        </p>
                                        <label className="switch_container">
                                            <input
                                                id="web-search-toggle"
                                                type="checkbox"
                                                checked={isMemoryEnabled}
                                                onChange={() => setIsMemoryEnabled(!isMemoryEnabled)}
                                            />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                    <div className="settings_link settings_link_actions">
                                        {t.playground.web_search}
                                        <label className="switch_container">
                                            <input
                                                id="web-search-toggle"
                                                type="checkbox"
                                                checked={isSearchEnabled}
                                                onChange={() => setIsSearchEnabled(!isSearchEnabled)}
                                            />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                    <div className="settings_link settings_link_actions">
                                        {t.playground.json_mode}
                                        <label className="switch_container">
                                            <input
                                                id="web-search-toggle"
                                                type="checkbox"
                                                checked={isJsonMode}
                                                onChange={() => setIsJsonMode(!isJsonMode)}
                                            />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>


                                    {loadingMcpData ? (
                                        <div>
                                            <SingleLoaderItem length={2} />
                                        </div>
                                    ) : (
                                        mcpData
                                            .filter((mcp) => mcp.is_connected === true)
                                            .map((mcp) => {
                                                const isChecked = connectors.some(conn => conn.id === mcp.id);

                                                const handleToggle = () => {
                                                    if (isChecked) {
                                                        setConnectors(connectors.filter((conn) => conn.id !== mcp.id));
                                                    } else {
                                                        const newConnector = {
                                                            id: mcp.id,
                                                            name: mcp.name,
                                                            type: mcp.type || 'mcp'
                                                        };
                                                        setConnectors([...connectors, newConnector]);
                                                    }
                                                };

                                                return (
                                                    <div className="settings_link settings_link_actions" key={mcp.id}>
                                                        <p className={`settings_link_connectors ${mcp.tag && "settings_link_tag"}`} title={mcp.tag ? `${mcp.name} - ${mcp.tag}` : mcp.name} >
                                                            {mcp.tag ? (
                                                                mcp.tag
                                                            ) : (
                                                                mcp.name
                                                            )}
                                                        </p>
                                                        {mcp.is_version_different && (
                                                            <span className="version_alert">
                                                                <MandatorySign message={t.different_version} icon="info" />
                                                            </span>
                                                        )}
                                                        <label className="switch_container">
                                                            <input
                                                                id={`mcp-${mcp.id}`}
                                                                type="checkbox"
                                                                checked={isChecked}
                                                                onChange={handleToggle}
                                                            />
                                                            <span className="slider round"></span>
                                                        </label>
                                                    </div>
                                                );
                                            })
                                    )}

                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                        <div className="run_settings_chips_cont">
                            {reasoningDepth !== "off" && (
                                <span className="run_settings_chips fade-in"><i><TbQuestionMark /></i>{reasoningDepth} {t.reasoning}</span>
                            )}
                            {isSearchEnabled && (
                                <span className="run_settings_chips fade-in"><i><TbListSearch /></i> {t.playground.web_search}</span>
                            )}
                            {isJsonMode && (
                                <span className="run_settings_chips fade-in"><i><VscJson /></i> {t.playground.json_mode}</span>
                            )}
                            {selectedSystemInstructions && (
                                <span className="run_settings_chips fade-in"><i><MdOutlineIntegrationInstructions /></i> {t.playground.sys_instructions}</span>
                            )}
                            {connectors.length > 0 && (
                                <>
                                    {connectors.slice(0, 2).map((connector) => (
                                        <span
                                            key={connector.id}
                                            className="run_settings_chips fade-in"
                                        >
                                            <i><PiPlugs /></i> {connector.name}
                                        </span>
                                    ))}

                                    {connectors.length > 3 && (
                                        <span className="run_settings_chips more_chip fade-in">
                                            +{connectors.length - 2}
                                        </span>
                                    )}
                                </>
                            )}
                        </div>
                    </div>

                    {isLoading ? (
                        <button className="chat_send_button" type="button" onClick={handleStopMessage}>
                            {t.stop} <Spinner loading={true} />
                        </button>
                    ) : (
                        <button
                            className={`chat_send_button ${!input.trim() ? "chat_send_button_loading" : ""}`}
                            type="submit"
                            disabled={!input.trim()}
                        >
                            {t.send} <i><HiArrowTurnRightUp /></i>
                        </button>
                    )}
                </div>
            </form>
        </div>
    );
};

export default ChatInterface;